import { PatientFieldComponent } from './patient-field/patient-field.component'

// Components
export * from './patient-field/patient-field.module'
export * from './patient-field/patient-field.component'

// Module
export { FormExtensionsModule } from './form-extensions.module'

export const formExtensions = {
  types: [
    {
      name: 'paciente',
      component: PatientFieldComponent
    }
  ]
}
